module.exports = __webpack_public_path__ + "img/shopee_9thb_0008.52cfb04c.png";